export const FEATURE_FLAGS = {
  LOGIN_ENABLED: false,
};
